// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"8575ccfe","787":"a54ccf53","850":"befec7a8"}[chunkId] + ".chunk.js";
};